import { getTranslate } from '@/tolgee/server';
import { ReactNode } from 'react';
import CyberButton from './CyberButton';
import NeonButton from './NeonButton';
import ReqTooltip from './ReqTooltip';

// 最简化的Button组件，不考虑向后兼容性
async function Button(props: {
  children?: ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
  style?: 'cyber' | 'neon';
}) {
  const { style = 'cyber', children, ...otherProps } = props;
  const t = await getTranslate();

  // 使用提供的children或默认使用下载文本
  const buttonText = children || t('provider_page.download_text');

  const buttonProps = {
    ...otherProps,
    children: buttonText,
  };

  if (style === 'cyber') {
    return <CyberButton {...buttonProps} />;
  }

  return <NeonButton {...buttonProps} />;
}

export { Button, CyberButton, NeonButton, ReqTooltip };
// Export original type for backward compatibility with other components
export type { ButtonProps } from './types';
